import Tag from "~/designSystem/components/Tags/Tag";

import roles from "~/lib/organizations/roles";
import MembershipRole from "~/lib/organizations/types/membership-role";

const RoleBadge: React.FCC<{
  role: MembershipRole;
}> = ({ role }) => {
  const data = roles.find(item => item.value === role);

  return (
    <Tag
      color={data?.value === MembershipRole.Owner ? "amber" : "slate"}
      text={data?.label ?? "Member"}
    />
  );
};

export default RoleBadge;
